module.exports = __webpack_public_path__ + "static/media/swish-logo.352bb8d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swish-logo.svg
// module id = 240
// module chunks = 0